<div class="comment">
    <div class="line" [ngClass]="{ 'active' : tabNum == 1  }"></div>
    <p *ngIf="tabNum == 0">评论</p>
    <div class="single_comment single_comment-{{relationId}}-{{i}}" *ngFor="let item of commentList;let i = index">
        <div class="infos">
            <div class="info">
                <img *ngIf="!item.studentCommentHeadimg" src="../../../assets/picture/camp/headPortrait.png" alt="">
                <img *ngIf="item.studentCommentHeadimg" src="{{item.studentCommentHeadimg}}" alt="">
                <span>{{item.studentCommentByName}}</span>
            </div>
            <span>{{item.studentCommentAt}}</span>
        </div>
        <div class="content">
            <pre class="con">{{item.studentComment}}</pre>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/component/comment/component.comment.html